import { ZorroInterceptorHttpParams } from './interceptors/zorro-interceptor-http-params';

export class ZorroApiClient {
    protected createOptions(data: { [key: string]: any }, spinnerMessage: string): ZorroInterceptorHttpParams {
        const params = this.createUrlParams(data);

        return new ZorroInterceptorHttpParams({ spinnerMessage }, params);
    }

    private createUrlParams(data: { [key: string]: any }): { [key: string]: any } {
        if (!data) {
            return null;
        }
        const params = {};
        Object.keys(data).forEach(key => {
            const value = data[key];
            // Don't add null/undefined values to the UrlParams object.
            if (value != null) {
                params[key] = value;
            }
        });
        return params;
    }
}
